import { Box } from '@mui/material';
import React from 'react';

interface DownloadButtonsContainerProps {
  children: React.ReactNode;
}

/**
 * Wrapper for one or more download buttons passed to `ReportDataSummary`'s
 * `downloadButtonsSlot` prop. Always use this wrapper — it handles flex layout,
 * right-alignment, and responsive full-width behaviour for every button inside it.
 *
 * ```tsx
 * <ReportDataSummary
 *   downloadButtonsSlot={
 *     <DownloadButtonsContainer>
 *       <DownloadCSVButton ... />
 *       <DownloadCSVButton ... />
 *     </DownloadButtonsContainer>
 *   }
 * />
 * ```
 */
const DownloadButtonsContainer = ({ children }: DownloadButtonsContainerProps) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'flex-end',
      flexWrap: 'wrap',
      gap: 1,
      width: '100%',
      // Mirror the parent Grid item's responsive rule so individual buttons
      // also become full-width on small screens.
      '& > *': { width: { xs: '100%', md: 'auto' } },
    }}
  >
    {children}
  </Box>
);

export { DownloadButtonsContainer };

